module.exports = __webpack_public_path__ + "img/nbus_box_4.ec5e66bf.jpg";